import { useState } from "react";
import { Lock, Loader2 } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const ADMIN_TOKEN_KEY = "fff_admin_token";

export function adminHeaders() {
  return { Authorization: "Bearer " + localStorage.getItem(ADMIN_TOKEN_KEY) };
}

export default function AdminLogin({ onLogin }) {
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const res = await fetch(BACKEND_URL + "/api/admin/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ password }),
      });
      const data = await res.json();
      if (!res.ok) {
        setError(typeof data.detail === "string" ? data.detail : "Login failed. Please try again.");
        return;
      }
      localStorage.setItem(ADMIN_TOKEN_KEY, data.token);
      onLogin();
    } catch {
      setError("Login failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0A1A2F] flex items-center justify-center px-4" data-testid="admin-login-page">
      <form onSubmit={submit} className="bg-white rounded-xl p-8 w-full max-w-sm shadow-2xl space-y-5" data-testid="admin-login-form">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-lg bg-[#D4A857]/15 text-[#D4A857] flex items-center justify-center">
            <Lock size={20} />
          </div>
          <div>
            <h1 className="text-xl font-bold text-[#0A1A2F] font-['Montserrat']">Admin Login</h1>
            <p className="text-xs text-gray-500 font-['Lato']">Fighting Fit Fencing dashboard</p>
          </div>
        </div>
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Admin password"
          required
          autoFocus
          className="w-full border border-gray-200 rounded-lg px-4 py-3 text-sm outline-none focus:ring-2 focus:ring-[#D4A857]/50"
          data-testid="admin-password-input"
        />
        {error && <p className="text-sm text-red-600" data-testid="admin-login-error">{error}</p>}
        <button
          type="submit"
          disabled={loading || !password}
          className="w-full bg-[#D4A857] hover:bg-[#C49A4D] text-[#0A1A2F] font-bold py-3 rounded-lg uppercase tracking-wide text-sm font-['Montserrat'] disabled:opacity-50 flex items-center justify-center"
          data-testid="admin-login-submit"
        >
          {loading ? <Loader2 size={18} className="animate-spin" /> : "Log in"}
        </button>
      </form>
    </div>
  );
}
